import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import config from "../../../config";

const baseUrl = config.baseUrl;

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 100,
    fontFamily: "Times-Roman",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  title_1: {
    fontSize: 13,
    textAlign: "left",
    fontWeight: "800",
    marginTop: 2,
  },
  title_respuesta: {
    fontSize: 10,
    marginTop: 7,
    textAlign: "justify",
    marginBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    textDecoration: "underline",
  },
  textareaLabel: {
    fontSize: 12,
    lineHeight: 2,
    textAlign: "justify",
    marginBottom: 12,
    marginTop: 12,
    fontFamily: "Times-Roman",
  },
  header: {
    marginBottom: 20,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  banner: {
    width: "100%",
    height: 40,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableInfo: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  tableTitle: {
    fontWeight: "bold",
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  codeText: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "center",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  text: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  footer: {
    position: "absolute",
    bottom: 20, // Coloca el footer al final de la página
    left: 20,
    right: 20,
    textAlign: "center",
    fontSize: 10,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    fontSize: 12,
    textAlign: "left",
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableHeader: {
    backgroundColor: "#f2f2f2", // Color de fondo para la cabecera
    fontWeight: "800",
  },
  tableCol: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    padding: 5,
    textAlign: "center",
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    fontSize: 10,
    padding: 5,
  },
  questionSection: {
    marginTop: 7,
  },
  questionText: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  checkbox: {
    width: 15,
    height: 15,
    borderWidth: 1,
    borderColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10, // Añadir separación entre la casilla y el texto
  },
  checkboxText: {
    fontSize: 10,
    color: "#000",
  },
  checkboxContainerHorizontal: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 7,
  },
  checkboxContainer: {
    flexDirection: "row",
    marginBottom: 10,
  },
  checked: {
    backgroundColor: "#fff",
    justifyContent: "center",
    marginR: 10,
    alignItems: "center",
    borderColor: "#000",
  },
  textarea: {
    fontSize: 10,
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
    borderRadius: 5,
    width: "100%", // Ajuste automático al ancho disponible
    minHeight: 40, // Asegura que tenga un mínimo de altura
    flexShrink: 1, // Permite que el contenedor ajuste su tamaño según el contenido
    backgroundColor: "#f0f0f0",
  },
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 20, // Agregar separación al final de la sección
  },
  signature: {
    width: 150,
    height: 50,
    marginBottom: 10,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginTop: 10,
  },
  interlineText: {
    marginTop: 15,
    fontSize: 10,
    textAlign: "center",
  },
  footerSpacer: {
    flexGrow: 1, // Esto empuja el contenido hacia arriba
  },
  column: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    alignItems: "center", // Centra los elementos dentro de las columnas
  },
  tableCol30: {
    width: "30%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  tableCol70: {
    width: "70%",
    padding: 5,
  },
  sectionTitle: {
    fontSize: 12,
    fontFamily: "Times-Bold",
    marginTop: 15,
    marginBottom: 10,
    textAlign: "center",
  },
  normalText: {
    fontSize: 12,
  },
  sectionExclusive: {
    marginTop: 20,
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  paragraph: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },
  blueText: {
    color: "#0000FF",
    textDecoration: "underline",
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  signatureTitle: {
    fontWeight: "bold",
    marginRight: 10,
  },
  signatureNote: {
    fontSize: 10,
    color: "#808080",
  },
  tableCol100: {
    width: "100%",
    padding: 5,
  },
  subtitleRow: {
    backgroundColor: "#f2f2f2",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  subtitleText: {
    fontSize: 11,
    fontWeight: "bold",
    textAlign: "center",
  },
  signatureBlock: {
    marginTop: 20,
    marginBottom: 20,
    width: "100%",
    minHeight: 120, // Añadido para mantener consistencia
  },
  signatureHeader: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
  },
  signatureContent: {
    marginLeft: 20,
    marginTop: 10,
    minHeight: 80, // Asegura espacio mínimo para la firma
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    width: "60%",
    marginBottom: 5,
  },
  signatureLabel: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 5,
  },
  signatureText: {
    fontSize: 12,
    marginBottom: 3,
    minHeight: 15, // Evita colapso cuando no hay texto
  },
  signatureImage: {
    width: 130,
    height: 70,
    marginBottom: 5,
  },
  signatureNote: {
    fontSize: 12,
    fontStyle: "italic",
    marginTop: 5,
    color: "#666",
    marginLeft: 20,
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 20,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Times-Bold", // <-- Esta línea hace el texto en negrita
  },
});

const MyDocument = ({ formData }) => {
  if (!formData) return null;

  return (
    <Document>
      <Page size="legal" style={styles.page}>
        <View fixed>
          <View style={styles.headerTable} fixed>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>

            <View style={styles.infoColumn}>
              <View style={styles.codeRow}>
                <Text style={styles.codeText}>
                  <Text style={{ fontWeight: "bold" }}>CÓDIGO: </Text>IR-F-113
                </Text>
              </View>
              <View style={styles.dateVersionRow}>
                <View style={styles.dateCell}>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>FECHA: </Text>
                    2020-07-14
                  </Text>
                </View>
                <View style={styles.versionCell}>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>VERSIÓN: </Text>V-1
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        <Text style={styles.title}>
          ACTA DE INICIO DE ASISTENCIA TÉCNICA PARA PROYECTOS PRODUCTIVOS
        </Text>

        {/* Agregar contenido del acta */}
        <View style={styles.section}>
          <Text style={styles.title_1}>
            Fecha: {formData?.dia || ""}
            {"/"}
            {formData?.mes || ""}
            {"/"}
            {formData?.vigencia || ""}
          </Text>

          {/* Título principal con numeración */}
          <Text style={styles.sectionTitle}>
            1. IDENTIFICACIÓN DEL PROYECTO PRODUCTIVO
          </Text>

          <View style={styles.table}>
            {/* Primera parte de la tabla */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Nombre del proyecto productivo:
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.nombre_proyecto || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Nombre de la forma Asociativa:
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.asociativo_individual || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Código del proyecto PRE-PP:
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.codigo_pre || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Número de personas en reincorporación vinculadas al proyecto
                  productivo
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.total_participantes || ""}
                </Text>
              </View>
            </View>

            {/* Subtítulo de Ubicación */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol100, styles.subtitleRow]}>
                <Text style={styles.subtitleText}>Ubicación del proyecto</Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>Departamento:</Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.departamento || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>Municipio:</Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.municipio || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>Vereda:</Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.direccion_proyecto || ""}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Acompañamiento y asistencia técnica por:
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.name_tecnico || ""}
                </Text>
              </View>
            </View>

            {/* Nuevos campos agregados */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>
                  Objetivo general del proyecto:
                </Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  Fortalecer los procesos de reincorporación económica y social
                  de personas en proceso de reincorporación con asistencia
                  técnica integral para los proyectos productivos individuales e
                  individuales asociativos
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={styles.tableCol30}>
                <Text style={styles.normalText}>Descripción del proyecto:</Text>
              </View>
              <View style={styles.tableCol70}>
                <Text style={styles.normalText}>
                  {formData?.descripcion || ""}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Sección para proyectos individuales */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            {formData?.nombre_participante || ""}, identificado(a) con CC, N°{" "}
            {formData?.codigo_sir || ""}, en calidad de beneficiario(a) del
            apoyo económico, debidamente acreditado(a) por la OACP, y la Agencia
            para la Reincorporación y la Normalización - ARN, representada por{" "}
            {formData?.nombreProfesionalARN || ""}, delegado por la ARN{" "}
            {formData?.grupoTerritorial || ""}, expresan su voluntad de dar
            inicio a partir de la suscripción de la presente acta a la ejecución
            de la asistencia técnica para el proyecto productivo antes citado y
            el interés de participar en todo el proceso.
          </Text>
        </View>

        {/* Sección de Acuerdo de Compromiso */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>2. ACUERDO DE COMPROMISO</Text>

          <Text style={styles.paragraph}>
            La(s) persona(s) en reincorporación encargada(s) de la ejecución del
            proyecto, se compromete(n) a participar en las actividades
            programadas para la implementación del mismo, acatar las
            recomendaciones que hagan los profesionales en la ejecución del
            acompañamiento y de la asistencia técnica al proyecto, participar en
            la elaboración y cumplimiento del POA y apoyar las actividades de
            seguimiento, de acuerdo con lo establecido en la Resolución 4309 de
            2019, Título II, Artículo 12.
          </Text>

          <Text style={styles.paragraph}>
            Las partes aquí descritas acuerdan que la Agencia para la
            Reincorporación y la Normalización - (ARN) está exenta de
            responsabilidad en toda controversia derivada del proyecto
            productivo escogido, entendiendo que dichos recursos serán
            administrados por la(s) persona(s) en reincorporación relacionados
            en el presente documento.
          </Text>
        </View>

        {/* Sección de Firmas */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>FIRMA DEL ACTA DE INICIO</Text>

          <Text style={styles.paragraph}>
            En constancia de lo anterior se suscribe la presente el día{" "}
            {formData?.dia || ""} del mes {formData?.mes || ""} del año{" "}
            {formData?.vigencia || ""}, en la ciudad de {formData?.ciudad || ""}
            .
          </Text>

          {/* Firma ARN 
          <View style={styles.signatureBlock}>
            <Text style={styles.signatureHeader}>
              Por ARN Grupo Territorial:
            </Text>
            <View style={styles.signatureContent}>
              {formData?.picture ? (
                <Image style={styles.signature} src={formData?.picture} />
              ) : (
                <Text style={styles.signatureText}>Firma no disponible</Text>
              )}
              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                Nombre: {formData?.nombreProfesionalARN || ""}
              </Text>
              <Text style={styles.signatureText}>
                No. Cédula: {formData?.numero_cedula_arn || ""}
              </Text>
              <Text style={styles.signatureText}>
                Cargo: {formData?.cargo_arn || ""}
              </Text>
            </View>
          </View>
*/}
          {/* Firma Persona Reincorporación */}
          <View style={styles.signatureBlock}>
            <Text style={styles.signatureHeader}>
              Firma del participante legal{" "}
              {formData &&
                formData?.tipo_autorizacion === "Firma Electrónica" &&
                "(Firma  por testigo)"}
            </Text>
            <View style={styles.signatureContent}>
              {formData?.tipo_autorizacion === "Grabación de Audio" ? (
                <>
                  <Text style={styles.signatureText}>
                    Firma disponible en audio
                  </Text>
                  <View style={styles.signatureLine} />
                </>
              ) : (
                <>
                  {formData.firma_participante &&
                  formData.firma_participante.trim() !== "" ? (
                    <Image
                      style={styles.signatureImage}
                      src={`${
                        baseUrl + formData.firma_participante
                      }?t=${Date.now()}`}
                    />
                  ) : (
                    <View
                      style={[
                        styles.signatureImage,
                        {
                          justifyContent: "center",
                          alignItems: "center",
                        },
                      ]}
                    >
                      <Text style={{ color: "#888", fontSize: 10 }}>
                        Firma no disponible
                      </Text>
                    </View>
                  )}
                  <View style={styles.signatureLine} />
                </>
              )}
              <Text style={styles.signatureText}>
                Nombre:{" "}
                {formData?.tipo_autorizacion === "Firma por Testigo"
                  ? formData?.nombre_testigo || ""
                  : formData?.nombre_participante || ""}
              </Text>
            </View>
          </View>

          {/* Firma Organización */}
          <View style={styles.signatureBlock}>
            <Text style={styles.signatureHeader}>
              Por parte de la Organización del acompañamiento y la asistencia
              técnica
            </Text>
            <View style={styles.signatureContent}>
              {formData.firma_tecnico &&
              formData.firma_tecnico.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
                  src={`${baseUrl + formData.firma_tecnico}?t=${Date.now()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 10 }}>
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                Nombre: {formData?.name_tecnico || "No especificado"}
              </Text>
              <Text style={styles.signatureText}>
                Cargo: {formData?.cargo_tecnico || "No especificado"}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfAlmacenarActaInicio = ({ formData }) => {
  return <MyDocument formData={formData} />;
};

export default PdfAlmacenarActaInicio;
